<ag-shr-modal-window
  #agencyInfoModalRef
  [width]="'860px'"
  [height]="'auto'"
  [title]="'Agency Information'"
  [inProgress]="inProgress$ | async"
  (onSaveClick)="handleSave()"
  [onCloseModal]="handleClosePopup"
>
  @if (agencyInfoModalRef?.popupComponent?.visible) {
    <dx-form
      #agencyInfoModalFormRef
      class="agency-header__form"
      [colCount]="4"
      [formData]="agencyFormDataSig()"
      [labelMode]="'floating'"
      [minColWidth]="100"
    >
      <dxi-item
        [dataField]="AgencyKeys.name"
        [colSpan]="2"
        [isRequired]="true"
        [label]="{ text: 'Agency Name' }"
        editorType="dxTextBox"
      ></dxi-item>

      <dxi-item
        [dataField]="AgencyKeys.agencyId"
        [label]="{ text: 'Agency ID' }"
        [colSpan]="2"
        [isRequired]="true"
        editorType="dxTextBox"
        [editorOptions]="{
          readOnly: !(Entity.agencyInformation | hasPermission: EntityPermissionActivityKeys.write | async),
        }"
      ></dxi-item>

      <dxi-item [dataField]="AgencyKeys.agencyNumber" [label]="{ text: 'Agency Number' }" [colSpan]="2"></dxi-item>

      <dxi-item
        [dataField]="AgencyKeys.agencyStatus"
        [label]="{ text: 'Agency Status' }"
        [colSpan]="2"
        editorType="dxSelectBox"
        [editorOptions]="{
          items: agencyStatusesLookup$ | async,
          valueExpr: BaseModelKeys.dbId,
          displayExpr: LookupKeys.description,
          searchEnabled: true,
          placeholder: '',
          onSelectionChanged: onSelectionChanged,
        }"
      ></dxi-item>

      <dxi-item
        [dataField]="AgencyKeys.agencyType"
        [label]="{ text: 'Agency Type' }"
        [colSpan]="2"
        editorType="dxSelectBox"
        [editorOptions]="{
          items: AGENCY_TYPES_LOOKUP,
          valueExpr: 'value',
          displayExpr: 'description',
          searchEnabled: true,
          placeholder: '',
        }"
      ></dxi-item>

      @if (agencyFormDataSig()?.agency_type === agencyType.MGA) {
        <dxi-item
          editorType="dxTextBox"
          [label]="{ text: 'MGA' }"
          [colSpan]="2"
          [editorOptions]="{
            readOnly: true,
            value: agencyFormDataSig()?.[AgencyKeys.name],
          }"
        >
        </dxi-item>
      } @else {
        <dxi-item
          [dataField]="AgencyKeys.mga"
          [label]="{ text: 'MGA' }"
          [colSpan]="2"
          editorType="dxSelectBox"
          [editorOptions]="{
            items: mgasLookup$ | async,
            valueExpr: AgencyKeys.agencyId,
            displayExpr: AgencyKeys.name,
            placeholder: '',
            searchEnabled: true,
          }"
        ></dxi-item>
      }

      <dxi-item
        [dataField]="AgencyKeys.startingMultiplier"
        [label]="{ text: 'Starting Multiplier' }"
        [colSpan]="2"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: [1, 2],
          displayExpr: percentageDisplayExpression,
          searchEnabled: false,
          showClearButton: false,
          placeholder: '',
        }"
      ></dxi-item>

      <dxi-item
        [dataField]="AgencyKeys.levelDivisor"
        [label]="{ text: 'Level Divisor' }"
        [colSpan]="2"
        editorType="dxSelectBox"
        [editorOptions]="{
          dataSource: [0.25, 0.5],
          displayExpr: percentageDisplayExpression,
          searchEnabled: false,
          showClearButton: false,
          placeholder: '',
        }"
      ></dxi-item>

      @if (agencyFormDataSig()?.[BaseModelKeys.dbId]) {
        <dxi-item
          [dataField]="AgencyKeys.agencyLead"
          [label]="{ text: 'Agency Lead' }"
          [colSpan]="2"
          editorType="dxSelectBox"
          [editorOptions]="{
            dataSource: agencyLeadsSig(),
            valueExpr: AgentKeys.p_agent_id,
            displayExpr: 'agent_display_name',
            searchEnabled: true,
            showClearButton: false,
            placeholder: '',
            readOnly: true,
            buttons: [
              {
                name: 'changeAgencyLead',
                options: {
                  icon: 'edit',
                  stylingMode: 'text',
                  hint: agencyFormDataSig()?.[AgencyKeys.agencyLead] ? 'Change Lead' : 'Assign Lead',
                  disabled: false,
                  onClick: handleUpdateAgencyLead,
                },
              },
            ],
          }"
        ></dxi-item>

        <!-- options: {
                    icon: 'key',
                    disabled: idGeneratingInProgress,
                    visible:
                      !agentDispositionFormDataSig()?.[AgentKeys.p_agent_id] && Entity.agentGenerateAgentId
                      | hasPermission
                      | async,
                    hint: 'Generate Agent ID',
                    onClick: generateAgentId,
                  }, -->

        <dxi-item
          [colSpan]="2"
          editorType="dxSelectBox"
          [dataField]="AgencyInfoModalKeys.primaryEmailAddress"
          [label]="{ text: 'Primary Email Address' }"
          [editorOptions]="{
            items: agencyFormDataSig()?.officeEmailAddress,
            displayExpr: 'address',
            searchEnabled: true,
            placeholder: '',
          }"
        >
        </dxi-item>

        <dxi-item
          [colSpan]="2"
          editorType="dxSelectBox"
          [dataField]="AgencyInfoModalKeys.primaryPhoneNumber"
          [label]="{ text: 'Primary Phone Number' }"
          [editorOptions]="{
            items: agencyFormDataSig()?.officePhoneNumbers,
            displayExpr: phoneNumberDisplayExpr,
            searchEnabled: true,
            placeholder: '',
          }"
        >
        </dxi-item>

        <dxi-item
          [colSpan]="2"
          editorType="dxSelectBox"
          [dataField]="AgencyInfoModalKeys.primaryShippingAddress"
          [label]="{ text: 'Primary Shipping Address' }"
          [editorOptions]="{
            items: agencyFormDataSig()?.addresses,
            displayExpr: fullAddressDisplayExpr,
            searchEnabled: true,
            placeholder: '',
          }"
        >
        </dxi-item>
      }

      <dxi-item
        [dataField]="AgencyKeys.rmds"
        [colSpan]="4"
        editorType="dxTagBox"
        [label]="{ text: 'RMDs' }"
        [editorOptions]="{
          items: rmds$ | async,
          displayExpr: 'agent_display_name',
          valueExpr: AgentKeys.p_agent_id,
          searchEnabled: true,
          showSelectionControls: true,
          applyValueMode: 'useButtons',
          placeholder: '',
        }"
      ></dxi-item>
    </dx-form>

    <ag-shr-modal-window
      #promptModelRef
      [title]="'Change MGA'"
      [modalId]="transferPromptModalId"
      [width]="'520px'"
      [height]="'auto'"
      [actionTitle]="'CONTINUE'"
      *var="agencyFormDataSig()?.[AgencyKeys.name] as agencyName"
    >
      <p>
        {{ agencyName }} has
        <a
          href="{{ promptSettingsSig()?.teamListUrl }}"
          target="_self"
          download="{{ agencyName }} hierarchy.xlsx"
          style="text-decoration: underline"
        >
          {{ promptSettingsSig()?.teamSize }} agent(s)</a
        >.
      </p>

      <p>You need to transfer agents before saving changes.</p>
    </ag-shr-modal-window>

    <ag-shr-modal-window
      #transferAgentModalRef
      [title]="'Reassign Agents'"
      [isFullScreen]="true"
      [modalId]="transferModalId"
      [actionTitle]="'CONFIRM'"
      [width]="'100%'"
      [height]="'100%'"
      [useScrollView]="false"
      [inProgress]="inTransferInProgress$ | async"
    >
      @if (transferAgentModalRef?.popupComponent?.visible) {
        <ag-crm-agency-hierarchy-management
          [mode]="AgencyHierarchyManagerMode.agencyTransfer"
          [unassignedGridTitle]="'Transfered Agents'"
        ></ag-crm-agency-hierarchy-management>
      }
    </ag-shr-modal-window>
  }
</ag-shr-modal-window>

<ag-shr-update-agency-lead-modal
  #updaterAgencyLeadModalRef
  [agencySig]="agencyFormDataSig()"
></ag-shr-update-agency-lead-modal>
